import { DEFAULT_SUBDOMAIN } from '../../../shared/constants';
import { createStore, IState } from '../../../shared/store';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { IReduxThunkContext } from '../../../shared/types/store';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const reduxContext: IReduxThunkContext = {
    ...context,
    subdomain: config.get<string>('subdomain') || DEFAULT_SUBDOMAIN,
  };

  const defaultState = config.getStrict<IState>('defaultState');

  return createStore(reduxContext, defaultState);
}
